import { CreditCounterpartyDetailProps } from '@graphql/query/operationLimits/credit/counterpartDetail';

import formatNegotiationDeadlineLabel from '~/utils/formatNegotiationDeadlineLabel';

const MONTHS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

const normalizeRating = (value?: string) =>
  String(value || '')
    .trim()
    .toUpperCase();

const getDecemberLabel = (offset: number) => {
  const year = new Date().getFullYear() + offset;

  return `Dez/${year}`;
};

const getCurrentMonthLabel = () => {
  const now = new Date();
  const monthLabel = MONTHS[now.getMonth()] || MONTHS[0];

  return `${monthLabel}/${now.getFullYear()}`;
};

export const resolveCounterpartySubtitle = (
  hasSelectedCounterparty: boolean,
  hasCounterpartyData: boolean,
  rating?: string,
  negotiationDeadlineLabel?: string,
) => {
  if (!hasSelectedCounterparty || !hasCounterpartyData) {
    return { ratingLabel: 'N/A', meaningLabel: '' };
  }

  const normalizedRating = normalizeRating(rating);

  if (!normalizedRating) {
    return { ratingLabel: 'N/A', meaningLabel: '' };
  }

  if (normalizedRating.includes('A+')) {
    return { ratingLabel: 'A+', meaningLabel: formatNegotiationDeadlineLabel(negotiationDeadlineLabel) || 'S/Restrição' };
  }

  if (normalizedRating.includes('A')) {
    return { ratingLabel: 'A', meaningLabel: formatNegotiationDeadlineLabel(negotiationDeadlineLabel) || getDecemberLabel(2) };
  }

  if (normalizedRating.includes('B')) {
    return { ratingLabel: 'B', meaningLabel: formatNegotiationDeadlineLabel(negotiationDeadlineLabel) || getDecemberLabel(1) };
  }

  if (normalizedRating.includes('C')) {
    return { ratingLabel: 'C', meaningLabel: formatNegotiationDeadlineLabel(negotiationDeadlineLabel) || getCurrentMonthLabel() };
  }

  return { ratingLabel: 'N/A', meaningLabel: '' };
};

export const resolveRatingStyle = (ratingLabel: string) => {
  if (ratingLabel === 'A+') {
    return { bg: '#38A169', shadow: 'none' };
  }

  if (ratingLabel === 'A') {
    return { bg: '#D69E2E', shadow: 'none' };
  }

  if (ratingLabel === 'B') {
    return { bg: '#DD6B20', shadow: 'none' };
  }

  if (ratingLabel === 'C') {
    return { bg: '#E53E3E', shadow: 'none' };
  }

  return { bg: '#718096', shadow: 'none' };
};

export const EMPTY_COUNTERPARTY_DETAIL: CreditCounterpartyDetailProps = {
  counterpartName: '',
  taxId: undefined,
  rating: undefined,
  negotiationDeadlineLabel: undefined,
  exposureMtmFiltered: 0,
  exposureMtmGlobal: 0,
  limitAverage: 0,
  financialBalance: 0,
  series: {
    mwmByCompetence: [],
    mtmByCompetence: [],
  },
};
